<template>
  <a-assets>
    <img id="logo-end-message" src="~assets/logo/logo-white.png">
    <a-asset-item id="frame-obj" src="static/models/frame.obj"></a-asset-item>
  </a-assets>
</template>

<script>

  export default {
    name: 'Assets',
    data: () => {
      return {}
    },
    mounted () {}
  }

</script>



// WEBPACK FOOTER //
// Assets.vue?4034ea90